import {
  OVERTIME_POLICY_CREATE,
  OVERTIME_POLICY_UPDATE,
  OVERTIME_POLICY_LIST,
  OVERTIME_REQUEST_CREATE,
  OVERTIME_REQUEST_PRE_APPROVAL,
  OVERTIME_REQUEST_APPROVE,
  OVERTIME_SUMMARY,
  OVERTIME_REPORT,
  OVERTIME_STAFF_SUMMARY_LIST,
  OVERTIME_STAFF_REQUESTS_LIST,
  OVERTIME_VIEW_REQUEST,
  OVERTIME_ADD_REQUEST,
} from "./apiRoutes";
import { authData } from "./Service";

// ── Policy ──────────────────────────────────────────────────────────────────

/** POST /api/overtime/policy — Create overtime policy */
export const createOvertimePolicyApi = async (data) => {
  const response = await authData.post(OVERTIME_POLICY_CREATE, data);
  return response?.data;
};

/** PUT /api/overtime/policy/{id} — Update overtime policy */
export const updateOvertimePolicyApi = async (id, data) => {
  const response = await authData.put(`${OVERTIME_POLICY_UPDATE}${id}`, data);
  return response?.data;
};

/** POST /api/overtime/listOfOvertimePolicy — Paginated list of overtime policies */
export const listOvertimePoliciesApi = async (data) => {
  const response = await authData.post(OVERTIME_POLICY_LIST, data);
  return response?.data;
};

/** GET /api/overtime/policy/{id}?organizationId={orgId} — View single overtime policy */
export const viewOvertimePolicyApi = async (id, orgId) => {
  const response = await authData.get(
    `${OVERTIME_POLICY_UPDATE}${id}${orgId ? `?organizationId=${orgId}` : ""}`,
  );
  return response?.data;
};

/** POST /api/overtime/request — Create overtime request */
export const createOvertimeRequestApi = async (data) => {
  const response = await authData.post(OVERTIME_REQUEST_CREATE, data);
  return response?.data;
};

/** POST /api/overtime/request/pre-approval — Create pre-approval overtime request */
export const createPreApprovalOvertimeRequestApi = async (data) => {
  const response = await authData.post(OVERTIME_REQUEST_PRE_APPROVAL, data);
  return response?.data;
};

/** PUT /api/overtime/approve/{requestId} — Approve or reject overtime request */
export const approveOvertimeRequestApi = async (requestId, data) => {
  const response = await authData.put(`${OVERTIME_REQUEST_APPROVE}${requestId}`, data);
  return response?.data;
};

// ── Summary & Reports ────────────────────────────────────────────────────────

/** GET /api/overtime/summary/{staffId} — Get staff overtime summary */
export const getOvertimeSummaryApi = async (staffId) => {
  const response = await authData.get(`${OVERTIME_SUMMARY}${staffId}`);
  return response?.data;
};

/** POST /api/overtime/report — Generate overtime report */
export const generateOvertimeReportApi = async (data) => {
  const response = await authData.post(OVERTIME_REPORT, data);
  return response?.data;
};

/** POST /api/overtime/listOfStaffOvertimeSummary — List staff members with overtime summary */
export const listStaffOvertimeSummaryApi = async (data) => {
  const response = await authData.post(OVERTIME_STAFF_SUMMARY_LIST, data);
  return response?.data;
};

/** POST /api/overtime/listOfStaffOvertimeRequests — List overtime requests & history for a specific staff member */
export const listStaffOvertimeRequestsApi = async (data) => {
  const response = await authData.post(OVERTIME_STAFF_REQUESTS_LIST, data);
  return response?.data;
};

/** GET /api/overtime/viewOvertimeRequest/:id — View single overtime request detail */
export const viewOvertimeRequestDetailsApi = async (id) => {
  const response = await authData.get(`${OVERTIME_VIEW_REQUEST}${id}`);
  return response?.data;
};

/** POST /api/overtime/addOvertimeRequest — Submit overtime request */
export const addOvertimeRequestApi = async (data) => {
  const response = await authData.post(OVERTIME_ADD_REQUEST, data);
  return response?.data;
};
